import React from 'react';
import { I18n } from 'react-redux-i18n';

export const STUDENT_STATUS_LABELS = {
  assigned: 'Нужно ответить',
  answered: 'Ответ отправлен',
  returned: 'На доработку',
  checked: 'Проверено',
};

export default function StatusBadge({ status, forStudent }) {
  const label = forStudent
    ? STUDENT_STATUS_LABELS[status] || status
    : I18n.t(`homework.status.${status}`);
  return <span className={`hw-st hw-st-${status}`}>{label}</span>;
}
